module.exports = __webpack_public_path__ + "static/img/about053.fa24586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about053.png
// module id = za5z
// module chunks = 1